import HTTP from '@/request/index'

// 可以把节流的时间调大一点，默认是100ms
if (window.IntersectionObserver) {
  window.IntersectionObserver.prototype['THROTTLE_TIMEOUT'] = 300
}
export default class {
  constructor(maxNum = 20) {
    // 当前收集的  尚未上报的数据  也就是已经进入视窗的DOM节点的数据
    this.dotDataArr = []
    this.maxNum = maxNum
    this._timer = 0
    // 全局只会实例化一次Exposure类，init方法也只会执行一次
    this.init()
  }

  init() {
    if (!window.IntersectionObserver) {
      return
    }
    const self = this
    // init只会执行一次，所以这两边界处理方法放这就行
    // 把浏览器localStorage里面的剩余数据打完
    this.dotFromLocalStorage()
    //不存在该api则忽略
    this._observer = new IntersectionObserver(
      function (entries, observer) {
        entries.forEach((entry) => {
          // 这段逻辑，是每一个商品进入视窗时都会触发的
          if (entry.isIntersecting) {
            // 清楚当前定时器
            clearTimeout(self._timer)
            // 我这里是直接把商品相关的数据直接放DOM上面了  比如 <div {...什么id  class style等属性} :data-dot="渲染商品流时自行加上自身属性" ></div>
            const eventk =
              (entry.target.attributes['data-buried'] &&
                entry.target.attributes['data-buried'].value) ||
              ''
            const eventv =
              (entry.target.attributes['data-eventv'] &&
                entry.target.attributes['data-eventv'].value) ||
              ''
            let list = eventk.split(',')
            list.map((item) => {
              // 把收集到的数据添加进待上报的数据数组中
              if (item) {
                self.dotDataArr.push({
                  eventk: item,
                  eventv: eventv
                })
              }
            })
            // 收集到该商品的数据后，取消对该商品DOM的观察
            self._observer.unobserve(entry.target)
            // 超过一定数量打点，打完点会删除这一批
            if (self.dotDataArr.length >= self.maxNum) {
              self.dot()
            } else {
              self.storeIntoLocalstorage(self.dotDataArr)
              if (self.dotDataArr.length > 0) {
                //，只要有新的ctm进来  接下来如果没增加  自动2秒后打
                self._timer = window.setTimeout(function () {
                  self.dot()
                }, 500)
              }
            }
          }
        })
      },
      {
        threshold: 0.3 // 不一定非得全部露出来  这个阈值可以小一点点
      }
    )
  }

  // 每个商品都会会通过全局唯一的Exposure的实例来执行该add方法,将自己添加进观察者中
  add(el, binding) {
    if (!window.IntersectionObserver) {
      return
    }
    this._observer && this._observer.observe(el)
  }
  remove() {
    if (!window.IntersectionObserver) {
      return
    }
    this._observer && this._observer.unobserve(el)
  }
  dot() {
    if (!window.IntersectionObserver) {
      return
    }
    const dotDataArr = this.dotDataArr.splice(0, this.maxNum)
    HTTP.bindH5UMAList(dotDataArr)
    // 打完点，也顺便更新一下localStorage
    this.storeIntoLocalstorage(this.dotDataArr)
  }

  storeIntoLocalstorage(dotDataArr) {
    // 。。。 存进localStorage中，具体什么格式的字符串自行定义就好
  }

  dotFromLocalStorage() {
    if (!window.IntersectionObserver) {
      return
    }
    const ctmsStr = window.localStorage.getItem('dotDataArr')
    if (ctmsStr) {
      // 。。。如果有数据，就上报打点
    }
  }
}
